import * as React         from 'react';
import classNames         from 'classnames';
import Dropzone           from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import { useNotification } from '../../../../providers/notification';

import DropZoneDeleteIcon from '../../../icons/DropZoneDeleteIcon';

const DropZoneField = function(props) {
  const { t } = useTranslation();

  const {
          accept,
          dropDescription,
          fields,
          fileSizeMb,
          icon,
          maxFiles,
          multiple,
          sizeDescription,
        } = props;

  const notification = useNotification();

  const checkFieldType = React.useCallback((field) => {
    if (field && !isSSR()) {
      const url = window.URL.createObjectURL(field);

      switch (true) {
        case field.type?.startsWith('image'):
          return (
            <img
              alt={field.name}
              src={url}
            />
          );

        case field.type?.startsWith('video'):
          return <video src={url}></video>;

        default:
          break;
      }
    }
  }, [fields]);
  const handleClick    = React.useCallback((event, key) => {
    event.preventDefault();
    event.stopPropagation();

    fields.remove(key);
  }, []);
  const onDrop         = React.useCallback((acceptedFiles) => {
    if (maxFiles && (fields.length + acceptedFiles.length > maxFiles)) {
      notification.showModal(
        t('notification.loading_error_title'),
        t('notification.loading_error_description.maximum_files'),
      );

      return;
    }

    const newFilesTotalSize = acceptedFiles.reduce((total, file) => total + file.size, 0);
    const allFields         = fields.getAll();

    const totalSize = allFields
      ? allFields.reduce((total, file) => total + file.size, 0) + newFilesTotalSize
      : newFilesTotalSize;

    if (fileSizeMb && totalSize > fileSizeMb * 1024 * 1024) {
      notification.showModal(
        t('notification.loading_error_title'),
        t('notification.loading_error_description.invalid_format'),
      );

      return;
    }

    acceptedFiles.forEach((file) => {
      fields.push(file);
    });
  }, [fields.length, maxFiles, fileSizeMb]);

  return (
    <div className={'dropzone_container'}>
      <Dropzone
        name={fields.name}
        multiple={multiple}
        onDrop={onDrop}
        accept={accept}
      >
        {(state) => {
          return (
            <div
              className={classNames('area', { fill: fields.length > 0 })}
              {...state.getRootProps()}
            >
              {fields.length === 0 && (
                <>
                  {icon}
                  <div className={'description_wrapper'}>
                    <h2 className={'title'}>{t('drop_zone.click_here')}</h2>
                    {dropDescription && <p className={'drop'}>{dropDescription}</p>}
                    {sizeDescription && <p className={'size'}>{sizeDescription}</p>}
                    {maxFiles && (
                      <p className={'quantity'}>
                        {`${t('drop_zone.quantity')} ${maxFiles} ${t('drop_zone.files')}`}
                      </p>
                    )}
                  </div>
                  <input {...state.getInputProps()} />
                </>
              )}
              {fields.length > 0 && (
                <div
                  className={'files'}
                  onClick={((event) => {
                    event.stopPropagation();
                  })}
                >
                  {fields
                    .getAll()
                    .map((field, f) => {
                      return (
                        <div
                          className={'file'}
                          key={f}
                        >
                          {checkFieldType(field)}
                          <div
                            className={'delete_btn'}
                            onClick={(event) => {
                              handleClick(event, f);
                            }}
                          ><DropZoneDeleteIcon /></div>
                        </div>
                      );
                    })
                  }
                  {maxFiles && fields.length < maxFiles && (
                    <div
                      className={'field_dropzone'}
                      {...state.getRootProps()}
                    >
                      {icon}
                      <input {...state.getInputProps()} />
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        }}
      </Dropzone>
    </div>
  );
};

export default DropZoneField;